<template>
	<v-row>
		<v-col>
			<v-form v-model="formIsValid" ref="basicForm">
				<ui-box
					:form="$refs.basicForm"
					eager
				>
					<v-row>
						<v-col>
							<h5>Basic Details</h5>
						</v-col>
					</v-row>

					<v-divider class="mb-10 mt-4 opacity-80"></v-divider>

					<v-row>
						<v-col>
							<v-text-field
								v-model="messageList.name"
								class="rounded-lg required"
								label="List Name"
								hide-details="auto"
								outlined
								requerid
								:rules="rules.name"
							></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<ui-box>

								<label>Description</label>

								<tiptap-vuetify
									ref="description"
									v-model="messageList.description"
									:card-props="{
											flat: true
										}"
									:extensions="extensions"

								></tiptap-vuetify>
							</ui-box>
						</v-col>

					</v-row>
				</ui-box>


				<save-form
					:refs="$refs"
					:is-saving="isSaving"
					:is-valid="formIsValid"
					save-text="Save"
					@cancel-action="cancelChanges"
					@save-action="saveChanges"
				></save-form>

			</v-form>
		</v-col>
	</v-row>
</template>

<script>

// Vuetify's CSS styles 
// import 'vuetify/dist/vuetify.min.css'

import {
	TiptapVuetify,
	Bold,
	Italic,
	Strike,
	Underline,
	BulletList,
	OrderedList,
	ListItem,
	HorizontalRule,
	History
} from 'tiptap-vuetify';

export default {
	name: 'EditMessageList',
	components: {
		TiptapVuetify
	},
	props: {
		// The incoming deal from an edit
		messageList: {
			type: Object,
		},
		partner: {
			type: Object | null,
			default: null
		},
		showSections: {
			type: Array,
			default: () => []
		},
		returnUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			formIsValid: false,
			isSaving: false,
			removeFaqDialog: false,
			indexToRemove: null,
			rules: {
				name: [v => !!v || 'Name is required.'],
			},
			extensions: [
				History,
				Italic,
				ListItem,
				Bold,
			],
		}
	},
	mounted() {
		this.setDefaultValues(this.messageList);
	},
	computed: {},
	methods: {


		getReturnUrl() {
			return `/partner-portal/${this.partner.id}/message-lists`;
		},
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		setDefaultValues(messageList) {
			//TODO: remove if it's not needed
		},
		saveChanges() {
			this.isSaving = true;
			let url = `/partner-portal/${this.partner.id}/message-lists/save-message-list/${this.messageList.id || ''}`;
			axios.put(url, this.messageList).then(response => {
				this.messageList.id = response.data.messageList.id;
				window.EventBus.$emit('system-messages', [
					{
						message: this.messageList.name + ' ' + (this.messageList.id
							? 'updated'
							: 'created') + ' - redirecting now...',
						messageType: 'success',
						showOverlay: true
					}
				]);
				setTimeout(() => {
					window.location = this.getReturnUrl();
				}, 2000);
			}).catch(error => {
				this.isSaving = false;
				window.EventBus.$emit('system-messages', [
					{message: error.message, messageType: 'error'}
				]);
			});

		}
	}
};

</script>
 